export default __webpack_public_path__ + "static/media/barber_back.5becbe6e.jpg";